import { config } from 'util/config';

export function getSectionDataByDefault({ parameter, sectionComponent, uie } = {}) {
  const componentDefaultValue = { ...sectionComponent.state.componentDefaultValue, [uie.source]: parameter };
  const searchParameter = { ...sectionComponent.props.searchParameter, ...sectionComponent.state.searchParameter, [uie.source]: parameter };

  sectionComponent.setState({ componentDefaultValue, searchParameter }, () => {
    setTimeout(() => sectionComponent.getSectionDataByDefault(), config.setTimeoutMilliSecond);
  });
}
